/**
 * Animated splash screen shown while the app bootstraps auth.
 *
 * Lifecycle:
 *   1. Mount: navy background visible immediately (matches native iOS splash
 *      so the handoff from Capacitor → JS is invisible).
 *   2. Logo fade-in (400ms).
 *   3. Hold while parent finishes bootstrapping auth.
 *   4. When parent sets `fadingOut`, the WHOLE overlay (logo + background)
 *      fades out together over 500ms, revealing the dashboard that has
 *      already mounted underneath. This produces a true cross-fade with
 *      no flash.
 */
import { useEffect, useState } from 'react';

export default function Splash({ fadingOut = false }) {
  const [logoIn, setLogoIn] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLogoIn(true), 50);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      data-testid="splash-screen"
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{
        backgroundColor: '#0B1824',
        opacity: fadingOut ? 0 : 1,
        transition: 'opacity 500ms ease-in-out',
        pointerEvents: fadingOut ? 'none' : 'auto',
        willChange: 'opacity',
      }}
    >
      <img
        src="/smarterhoops-logo.png"
        alt="SmarterHoops"
        className="w-56 max-w-[60vw] select-none pointer-events-none"
        draggable="false"
        style={{
          opacity: logoIn ? 1 : 0,
          transition: 'opacity 400ms ease-in-out',
        }}
      />
    </div>
  );
}
